import { FaGlobeAmericas, FaSuitcaseRolling, FaCalendarAlt, FaUsers } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaGlobeAmericas />, // Globe icon for Destinations
        title: 'Global Destinations',
        count: '150',
    },
    {
        id: 2,
        icon: <FaSuitcaseRolling />, // Suitcase icon for Tours Organized
        title: 'Tours Organized',
        count: '1200',
    },
    {
        id: 3,
        icon: <FaCalendarAlt />, // Calendar icon for Years of Service
        title: 'Years of Service',
        count: '25',
    },
    {
        id: 4,
        icon: <FaUsers />, // Users icon for Happy Travelers
        title: 'Happy Travelers',
        count: '5000',
    },
];

export default counter;